exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".announcementSnackbar-iconButton {\n  color: inherit;\n  justify-content: flex-start;\n  margin-bottom: 16px; }\n\n.announcementSnackbar-root {\n  background-color: #edc9c9;\n  color: var(--error-text-color);\n  width: 100%;\n  flex-wrap: nowrap; }\n\n.announcementSnackbar-warningIcon {\n  margin-right: 12px; }\n\n.announcementSnackbar-messageContainer {\n  display: flex;\n  justify-content: space-between; }\n\n.announcementSnackbar-messageText {\n  color: var(--error-text-color);\n  font-size: 16px;\n  padding-top: 4px; }\n", ""]);

// exports
